<template>
  <div class="header__col header__col--nav">
    <button class="header__burger header__burger--animation" type="button">
      <span class="header__burger-box">
        <span class="header__burger-inner"></span>
      </span>
    </button>

    <nav class="header__nav">
      <ul class="header__nav-list">
        <li
          v-for="menu in mainmenue"
          v-bind:key="menu.id"
          class="header__nav-item"
          :class="{ current: $route.path.startsWith(menu.url) }"
        >
          <router-link v-bind:to="menu.url" class="header__nav-link">
            {{ menu.menue }}
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'MainMenue',
  props: {
    mainmenue: {
      type: Object,
    },
  },
};
</script>
